import { keycloak } from '../keycloak';
import { ensureFreshToken } from './keycloakToken';

export const buildAuthHeaders = async (accept) => {
  await ensureFreshToken();
  let myHeaders = new Headers();
  const token = keycloak.token;
  myHeaders.append('Authorization', `Bearer ${token}`);
  accept
    ? myHeaders.append('Accept', '*/*')
    : myHeaders.append('Content-Type', 'application/json');
  return myHeaders;
};
